import React from "react";
import {
  FaClipboardList,
  FaPaintBrush,
  FaCogs,
  FaShieldAlt,
} from "react-icons/fa";
function RequirementAnalysis() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  How Do We Develop a Clone Crypto Wallet App?
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaClipboardList size={40} />
                  </div>
                  <h4>Requirement Analysis</h4>
                  <p>
                    We begin by understanding your specific business
                    requirements, target audience, and the features you want to
                    replicate from popular wallets like MetaMask, Trust Wallet,
                    or Coinbase Wallet. We also discuss any additional
                    functionality you need, such as multi-currency support,
                    staking, or custom branding.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaPaintBrush size={40} />
                  </div>
                  <h4>UI/UX Design Customization</h4>
                  <p>
                    Our team customizes the user interface and design based on
                    your brand identity, ensuring a sleek, user-friendly
                    experience. We replicate the intuitive designs of popular
                    wallets and tailor them to suit your preferences.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCogs size={40} />
                  </div>
                  <h4>Core Features Development</h4>
                  <p>
                    We clone the essential features of leading crypto wallets,
                    such as private key management, transaction history, QR code
                    scanning, in-app token swaps, and multi-signature security.
                    These features ensure seamless transactions and secure
                    storage of assets.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaShieldAlt size={40} />
                  </div>
                  <h4>Security Enhancements</h4>
                  <p>
                    Security is at the core of our wallet clone development. We
                    implement encryption protocols, biometric authentication,
                    multi-factor authentication (MFA), and seamless integration
                    of KYC/AML protocols to ensure compliance and safeguard user
                    assets.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RequirementAnalysis;
